<template>
    <form
        @submit.prevent="submit"
        ref="ajaxForm"
        :class="{ disabled: isLoading }"
    >
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <slot
            :formData="formData"
        />
    </form>
</template>

<script>
    import axios from 'axios';
    import { mapMutations } from 'vuex';

    import UiSpinner from '../ui/spinner.vue';

    export default {
        name: 'UiAjaxForm',
        components: {
            UiSpinner,
        },
        props: {
            action: {
                type: String,
                default: null,
            },
            callback: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                formData: {},
                isLoading: false,
            };
        },
        created() {
            eventHub.$once('ajaxFormLoad', async (object) => {
                this.isLoading = true;

                const { data } = await axios.get(object.route, {
                    params: {
                        id: object.id,
                    },
                });

                Object.keys(data).forEach((item) => {
                    this.formData.id = object.id;
                    this.formData[item] = data[item];
                });

                this.isLoading = false;
            });
        },
        destroyed() {
            this.isLoading = false;
        },
        methods: {
            ...mapMutations('modal', [
                'setModal',
            ]),

            async submit() {
                this.isLoading = true;

                const formData = new FormData(this.$refs.ajaxForm);

                try {
                    await axios.post(this.action, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });

                    this.setModal(null);
                    eventHub.$emit(this.callback);
                } finally {
                    this.isLoading = false;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .spinner-holder {
        z-index: 2;
    }
</style>
